<template>
  <scroll
    class="brand-list-wrapper pxstrict"
    :class="{ 'has-tab': hasTab }"
    ref="brandList"
    :data="data"
  >
    <ul class="content">
      <li
        :class="{ active: active === item.brandId }"
        :ref="item.brandId"
        @click="selectBrand(item.brandId)"
        v-for="item in data"
        :key="item.brandId"
      >
        {{ item.brandName }}
      </li>
    </ul>
  </scroll>
</template>

<script>
import Cookie from "js-cookie";
import scroll from "../../../components/scroll.vue";
export default {
  name: "choose_phone_model",
  props: ["data", "hasTab", "active"],
  data() {
    return {
      categoryScroll: null,
    };
  },
  components: {
    scroll,
  },
  methods: {
    /**
     * 重新计算滚动插件
     */
    refreshScroll() {
      this.categoryScroll.refresh();
    },
    /**
     * 选择品牌
     * @param id
     */
    selectBrand(id) {
      this.scrollToElement();
      this.$emit("onchange", id);
    },
    /**
     * 点击品牌后滚动到该位置
     */
    scrollToElement() {
      setTimeout(() => {
        let li = document.querySelector(".active");
        this.$refs.brandList.scrollToElement(li, 600, true, true);
      }, 35);
    },
  },
};
</script>


<style lang="less" scoped>
.brand-list-wrapper.pxstrict{
	top: 130px;
}
.brand-list-wrapper {
  overflow: hidden;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 188px;
  background: #fff;
  li {
    height: 96px;
    line-height: 96px;
    text-align: center;
    font-size: 28px;
    color: #999;
  }
  .active {
    color: #333;
    background: #f7f7f7;
  }
}
.brand-list-wrapper.pxstrict.has-tab {
  top: 132px;
}
</style>
